import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PrintOfficePageRoutingModule } from './print-office-routing.module';

import { PrintOfficePage } from './print-office.page';
import { SharedModule } from '../shared/shared.module';
import { PrintOfficeHeaderComponent } from './print-office-header/print-office-header.component';
import { PrintOfficeStatsComponent } from './print-office-stats/print-office-stats.component';
import { TranslateModule } from '@ngx-translate/core';
import { CustomSpTableComponent } from "../shared/custom-sp-table/custom-sp-table.component";
import { PrintOfficeAvailabilityPage } from '../provider/print-office-availability/print-office-availability.page';
import { PrintOrderDetailsPage } from '../provider/print-order-details/print-order-details.page';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, PrintOfficePageRoutingModule, SharedModule, TranslateModule],
  declarations: [PrintOfficePage, PrintOfficeHeaderComponent, PrintOfficeStatsComponent, PrintOfficeAvailabilityPage, PrintOrderDetailsPage],
})
export class PrintOfficePageModule {}
